import request from '../../utils/request'
import config from '../../../config/config'
const baseURL = config.baseUrl

//  信息新增
export function printNoAdd (data) {
  return request({
    url: baseURL + 'printNo/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function printNoList (data) {
  return request({
    url: baseURL + 'printNo/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function printNoDelete (data) {
  return request({
    url: baseURL + 'printNo/delete',
    method: 'post',
    data: data
  })
}
//  信息修改
export function printNoUpdate (data) {
  return request({
    url: baseURL + 'printNo/update',
    method: 'post',
    data: data
  })
}
//  信息打印
export function printNoPrint (data) {
  return request({
    url: baseURL + 'print/print',   
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/printNo/index.js